module.exports = __webpack_public_path__ + "static/media/team3.2f6c0409.jpg";